
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"26","viewBox":"0 0 26 26","width":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f44747"}},[_c('path',{attrs:{"d":"M13.76 15.507h-1.428l-.157-7.02h1.75zm-1.633 2.146a.87.87 0 01.253-.642c.169-.173.399-.26.69-.26s.522.087.69.26a.87.87 0 01.254.642c0 .251-.082.46-.246.63-.164.168-.397.252-.698.252s-.533-.084-.697-.253a.866.866 0 01-.246-.629z"}}),_c('path',{attrs:{"d":"M13 2a11 11 0 110 22 11 11 0 010-22zm0-1a12 12 0 100 24 12 12 0 000-24z","stroke":"#f44747","stroke-width":".5"}})])])
          )
        }
      }
    